// You can write your custom Javascript here
/*** Page sidebar script start ***/

function throttle(fn, delay) {
  var last = 0, timer = null;
  return function () {
    var now = Date.now(), self = this, args = arguments;
    if (now - last >= delay) {
      last = now;
      fn.apply(self, args);
    } else if (!timer) {
      timer = setTimeout(function () {
        timer = null;
        last = Date.now();
        fn.apply(self, args);
      }, delay);
    }
  };
}

function getCookie(name) {
    	const v = document.cookie.match('(^|;) ?' + name + '=([^;]*)(;|$)');
    	return v ? v[2] : null;
	}


	function setCookie(name, value, days) {
   		const d = new Date;
  	 	d.setTime(d.getTime() + 24*60*60*1000*days);
   	 	document.cookie = name + "=" + value + ";path=/;expires=" + d.toGMTString();
	}


$(window).on('load', function(){
  var str1 = window.location.href;
  $( ".sort__select option" ).each(function() {
    var str2 = $(this).attr('value');
    if(str1.indexOf(str2) != -1)
    {
      $(this).attr('selected','selected');
    }
  });

});

$('.sort__select').on('change', function () {

  var current_val = $(this).val();  
  window.location.href = current_val;
});

$('.mobile_sidebar').change(function(){
  var current_val = $(this).val();  
  window.location.href = current_val;
}); 

/*mobileload();
$(window).resize(function() {
  mobileload();
});*/

function getMobileOperatingSystem() {
  var userAgent = navigator.userAgent || navigator.vendor || window.opera;

  // Windows Phone must come first because its UA also contains "Android"
  if (/windows phone/i.test(userAgent)) {
    return "Windows Phone";
  }

  if (/android/i.test(userAgent)) {
    return "Android";
  }

  // iOS detection from: http://stackoverflow.com/a/9039885/177710
  if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
    return "iOS";
  }

  return "unknown";
}

function mobileload(){
  var mobile = getMobileOperatingSystem();
  //console.log(mobile);
  if(mobile!="unknown"){
    if(mobile == "iOS" ||  mobile == "Android" || mobile == "Windows Phone" ){
      /*$('.sidebar_linklist').hide();
      $('.mobile_drop').show();
      $('.mobile_sidebar').show();*/
    }
  }else{
    /*$('.mobile_drop').hide();
     $('.sidebar_linklist').show();*/
  }
}

$(document).ready(function(){
  /*movepageScroller();*/
})
$(window).on('resize',function(){
  /*movepageScroller();*/
})

function readDeviceOrientation() {

  if (Math.abs(window.orientation) === 90) {
    // Landscape
    $('.desktopDevice').show();
    $('.mobileDevice').hide();
  } else {
    // Portrait
    $('.mobileDevice').show();
    $('.desktopDevice').hide();
  }
}

window.onorientationchange = readDeviceOrientation;

function resposiveFun()
{

  if($(window).width() < 767)
  {      

    if(window.orientation == 0 ){
      $('.mobileDevice').show();
      $('.desktopDevice').hide();
    }
    else{
      $('.desktopDevice').show();
      $('.mobileDevice').hide();
    }
  }
  else
  {
    $('.desktopDevice').show();
    $('.mobileDevice').hide();
  }

}

function productpageStickyfun() {
  if (!$('body').hasClass('template-product')) return;
  var $anchor = $(".section__body");
  var $scroller = $('.product-single');
  var $footer = $('.section--related-products');
  if (!$scroller.length || !$anchor.length || !$footer.length) return;
  var getWidthVal = $scroller.width();

  if ($(window).width() > 767) {
    var move = throttle(function() {
      var winOffset = $(window).scrollTop();
      var st = winOffset + $('#shopify-section-header').height() + 20;
      var ot = $anchor.offset().top;
      var ft = $footer.offset().top;
      var sh = $scroller.height();
      var div_height = $('#shopify-section-header').height() + 20;
      if (st > ot && (st + sh + 50) < ft && (ft - div_height) > winOffset + $scroller.height()) {
        $scroller.css({ position: "fixed", top: div_height + "px", width: getWidthVal + 'px' }).addClass('sticky-active');
      } else {
        if ($('.section__images').offset().top < $(window).scrollTop()) {
          $scroller.css({
            position: "relative",
            top: ($('.section__images').height() - $scroller.height()) + 'px',
            width: getWidthVal + 'px'
          }).removeClass('sticky-active');
        } else {
          $scroller.css({ position: "relative", top: '' }).removeClass('sticky-active');
        }
      }
    }, 50);
    $(window).off('scroll.productSticky').on('scroll.productSticky', move);
    move();
  } else {
    $scroller.css({ position: "relative", top: "" });
    $(window).off('scroll.productSticky');
  }
}

function movepageScroller() {
}
/*** Page sidebar script ends ***/



// You can write your custom Javascript here

jQuery(document).ready(function() {  

  // Search focus increase the width
  jQuery('.header__search .search__field-focus').focus(function() {
    jQuery(this).closest('.header__search').addClass('search__focus');    
    jQuery(this).attr('placeholder', 'Search Needle & Thread');
  });
  jQuery('.header__search .search__field-focus').blur(function() {
    jQuery(this).closest('.header__search').removeClass('search__focus');
    jQuery(this).attr('placeholder', 'Search…');
  });

  var width = jQuery(window).width();
  if(width>=320 && width<=767){
    jQuery('.cart_right').hide();  
    mobileScroller();
  }else{
    jQuery('.cart_right').show();
  }  


  jQuery('.quantity_plus').click(function(){
    var id = jQuery(this).attr("data-id");
    var qy = jQuery("#quantity_"+id).val();
    var qty = parseInt(qy)+parseInt(1);
    var data = "updates["+id+"]="+qty;
    var  c=  $('.field--quantity').attr('max');

    if( c == undefined)
    {

      $('#errmsg').text("");
      jQuery.ajax({
        url: '/cart/update.js',
        type: 'POST',
        dataType: 'json',
        data: data,
        success: function(result) { 
          setTimeout(function(){
            window.location.href = window.location.href;
          }, 1500);
        },
        error: function(jqxhr, status, exception) {
          console.log(exception);
        }
      });
    }
    else{
      if(qy < c)
      {

        $('#errmsg').text("");
        jQuery.ajax({
          url: '/cart/update.js',
          type: 'POST',
          dataType: 'json',
          data: data,
          success: function(result) { 
            setTimeout(function(){
              window.location.href = window.location.href;
            }, 1000);
          },
          error: function(jqxhr, status, exception) {
            console.log(exception);
          }
        });
      }
      else{
        $('#errmsg').text("Please select a lower quantity");
        return false;
      }
    }

  });
  jQuery('.quantity_minus').click(function(){
    var id = jQuery(this).attr("data-id");
    var qy = jQuery("#quantity_"+id).val();
    var qty = parseInt(qy)-parseInt(1);
    var data = "updates["+id+"]="+qty;
    jQuery.ajax({
      url: '/cart/update.js',
      type: 'POST',
      dataType: 'json',
      data: data,
      success: function(result) { 
        setTimeout(function(){
          window.location.href = window.location.href;
        }, 1000);
      },
      error: function(jqxhr, status, exception) {
        console.log(exception);
      }
    });
    return false;
  });  


  /* Header Search show/shide */  
  $(".link-search").click(function(){
    $(".desk_search").slideToggle();
  });


  /* Scroll top */
  var $scrollTopBtn = $(".scroll__top");
  if ($scrollTopBtn.length) {
    $(window).on('scroll.scrollTop', throttle(function() {
      var topPos = $(this).scrollTop();
      $scrollTopBtn.css("opacity", topPos > 100 ? "1" : "0");
    }, 100));
  }

  if ($scrollTopBtn.length) {
    $scrollTopBtn.on('click', function() {
      $('html, body').animate({ scrollTop: 0 }, 1200);
      return false;
    });
  }


});



var cartResizeHandler = throttle(function() {
  var width = jQuery(window).width();
  if (width >= 320 && width <= 767) {
    jQuery('.cart_right').hide();
    jQuery(window).off('scroll.cartSticky');
    cartStickyScrollAttached = false;
    mobileScroller();
  } else {
    jQuery('.cart_right').show();
    jQuery(window).off('scroll.cartMobile');
    cartMobileScrollAttached = false;
    moveScroller();
  }
}, 150);
jQuery(window).on('resize.cartSticky', cartResizeHandler);

/* CART STICK */
var cartStickyScrollAttached = false;

function moveScroller() {
  if (!$('body').hasClass('template-cart')) return;
  var $anchor = $(".cart_right");
  var $scroller = $('#scroller');
  var $footer = $('.footer');
  var $tableCart = $('.table--cart');
  var $header = $('#shopify-section-header');
  if (!$anchor.length || !$scroller.length || !$tableCart.length || !$footer.length || !$header.length) return;

  var move = throttle(function() {
    var st = $(window).scrollTop() + $header.height();
    var ot = $anchor.offset().top;
    var tableCarthgt = $tableCart.outerHeight();
    var tableCartofst = $tableCart.offset().top;
    var cart_right_height = $scroller.outerHeight();
    var ft = $footer.offset().top;
    var stickBottom = $(window).scrollTop() + $scroller.height() + $header.height() + 50;

    if (st > ot && $(window).width() > 990 && ft > stickBottom) {
      $scroller.addClass("scrolladded").css({ position: "fixed", top: "125px", width: "348px" });
    } else if (tableCartofst < $(window).scrollTop()) {
      $scroller.removeClass("scrolladded").css({
        position: "relative",
        top: $tableCart.height() - $scroller.height(),
        width: "348px"
      });
    } else {
      $scroller.removeClass("scrolladded").css({ position: "relative", top: "", width: "348px" });
    }
    if (tableCarthgt < cart_right_height) {
      $scroller.removeClass("scrolladded").css({ position: "relative", top: "", width: "348px" });
    }
  }, 50);

  if (!cartStickyScrollAttached) {
    $(window).on('scroll.cartSticky', move);
    cartStickyScrollAttached = true;
  }
  move();
}

var cartMobileScrollAttached = false;

function mobileScroller() {
  if (!$('body').hasClass('template-cart')) return;
  var $mobileSticky = $('.mobile-sticky');
  var $scrollTop = $('.scroll_top');
  var $cartRight = $(".cart_right");
  if (!$mobileSticky.length || !$scrollTop.length || !$cartRight.length) return;

  var mobilesc = throttle(function() {
    var st = $mobileSticky.offset().top;
    var ot = $scrollTop.offset().top + 60;
    if (st > ot) {
      $mobileSticky.css({ visibility: 'hidden', 'z-index': '-1' });
      $cartRight.show();
    } else {
      $cartRight.hide();
      $mobileSticky.css({ visibility: 'visible', 'z-index': '8' });
    }
  }, 50);

  if (!cartMobileScrollAttached) {
    $(window).on('scroll.cartMobile', mobilesc);
    cartMobileScrollAttached = true;
  }
  mobilesc();
}


/* product page Variant restrict When it is ot available */

function convertToSlug(Text)
{
  return Text.toLowerCase().replace(/ /g,'-').replace(/[^\w-]+/g,'');
}

var finalsplitedArr = []
var colorArr = [];
var sizeArr = [];
var totcolorArr = [];
var totsizeArr = [];
var myVariantObj = {}
$(document).ready(function(){

  if($('body').hasClass('template-product'))
  {
    var variantValues = ($('.variantClass').val()).split(',');
    var totVariantValue = ($('.totvariantClass').val()).split(','); 
    $.each(totVariantValue,function(i,v){
      var totsplitedVal = v.split('/')
      totcolorArr.push(totsplitedVal[0]);
      totsizeArr.push(totsplitedVal[1]);
    });
    $.each(variantValues,function(i,v){
      var splitedVal = v.split('/')
      colorArr.push(splitedVal[0]);
      sizeArr.push(splitedVal[1]);
    });


    //console.log(totcolorArr)
    $.each(totcolorArr,function(i,v){
      v = v.toLowerCase().trim()
      if(myVariantObj[v] == undefined)
      {
        myVariantObj[v] = [];
        myVariantObj[v].push(totsizeArr[i]);
      }
      else
      {
        myVariantObj[v].push(totsizeArr[i]);
      }
    });

    var firstSizeVal = '';
    $('.main-list-variants').eq(0).find('li label').on('click',function(){
      if($(this).attr('class').indexOf('color') != -1)
      {
        var findColor = $(this).siblings('input').val();
        $('.main-list-variants').eq(1).find("input").parent().addClass('variant__ofs');

        $.each(myVariantObj[findColor],function(i,v){

          v = v.toLowerCase().trim().replace(' ','-')
          if(i==0) firstSizeVal = v;
          $('#size-'+v).parent().removeClass('variant__ofs');
        });
        $('#size-'+firstSizeVal).trigger('click');
      }
    })

    if(colorArr[0] == ''){
      $( ".main-list-variants li:first").find('label').trigger('click');
    }else{

      $('.color-'+colorArr[0].toLowerCase().trim()).trigger('click');
    }
  }

  // collection page 

  if ($('body').hasClass('template-collection') || $('body').hasClass('template-search')) {
    $(document).on('click', '.dropdownbox', function() {
      var $dropdownbox = $(this);
      
      // Check if this is the first time clicking this specific dropdown
      if ($dropdownbox.data('initialized')) {
        return; // Already initialized, skip
      }
      
      // Mark as initialized
      $dropdownbox.data('initialized', true);
      
      var $form = $dropdownbox.closest('form');
      var $options = $form.find('select option');
      var $variantListItems = $form.find('.main-list-variants li');
      var $notifyTextSpans = $form.find('.main-list-variants li label .notify-me-text');
  
      $options.each(function(index) {
        if ($(this).is(':disabled')) {
          var liIndex = index + 1;
  
          if ($variantListItems.eq(liIndex).length) {
            $variantListItems.eq(liIndex).addClass('variant__ofs');
          }
  
          if ($notifyTextSpans.eq(liIndex).length) {
            $notifyTextSpans.eq(liIndex).text('Notify Me When Available');
          }
        }
      });
    });
}
})

/* product page Variant restrict When it is ot available */




/* Modal Size chart functionality */
var tableArr_0 = [];
var tableArr_1 = [];
var getId = 0;
var indexVal = 0;
var trigId = $('#sizeId_0')
var startVal = -1;
var startVal1 = -1;
/* Modal Size chart functionality */

$(document).ready(function(){

  $('#SizeChartBtnClick').on('click',function(){
    $('#modal-size-chart').attr("aria-hidden","false");
  })
  $('.Modal__Close').on('click',function(){
    $('#modal-size-chart').attr("aria-hidden","true");
  })


  $('.toggleBtn').off('click').on('click',togglefunction);

  $('.sizeChartList').off('click').on('click',sizelistfunc);
  $(window).on('resize',function(){
    resposiveFun();
  });
  var totLen =  $('.desktopDevice #toggleBlock_0 table tr').length;
  var tdLen =   $('.desktopDevice #toggleBlock_0 table tr').eq(0).children('td').length;
  var totLen1 =  $('.desktopDevice #toggleBlock_1 table tr').length;
  var tdLen1 =   $('.desktopDevice #toggleBlock_1 table tr').eq(0).children('td').length;
  //console.log(totLen,tdLen)
  $('.desktopDevice #toggleBlock_0 table tr').each(function(i,v){
    tableArr_0[i]=[];
  });
  $('.desktopDevice #toggleBlock_0 table tr td').each(function(i1,v1){
    if(i1%tdLen1 == 0) startVal++;       
    //tableArr_0[startVal][i1%tdLen] = (v1.innerHTML).trim();
  });
  $('.desktopDevice #toggleBlock_1 table tr').each(function(i,v){
    tableArr_1[i]=[];
  });
  $('.desktopDevice #toggleBlock_1 table tr td').each(function(i1,v1){
    if(i1%tdLen1 == 0) startVal1++;
    //tableArr_1[startVal1][i1%tdLen1] = (v1.innerHTML).trim();
  });
  //console.log(tableArr_0)
  //console.log(tableArr_1)
  $('#toggle_0').trigger('click');
  resposiveFun();


});



function togglefunction()
{
  getId = $(this).attr('id').split('_')[1];
  $('.toggleBtn').removeClass('is-active');
  $(this).addClass('is-active');
  $('.togglecontent').hide()
  $('#toggleBlock_'+getId).show();
  trigId.trigger('click');
}

function sizelistfunc()
{
  var sizeId = $(this).children('label').html().trim();
  trigId = $(this);
  $('.SizeSwatchlist_radio').removeAttr('checked');
  $(this).children('li input').attr('checked','checked');
  $('.modelSizeSwatch').removeClass('activeLabel')
  $(this).children('li input').siblings('label').addClass('activeLabel');
  $.each(window['tableArr_'+getId],function(i,v){
    if(sizeId == window['tableArr_'+getId][i][0])
    {
      indexVal = i;
      return;
    }
  });
  $('.Selectedsizecontent').empty();
  //if(window['tableArr_'+getId].lenght>1)
  {
    if(sizeId ==window['tableArr_'+getId][indexVal][0]){
      $('.Selectedsizecontent').show();
      $.each(window['tableArr_'+getId][indexVal],function(i,v){
        $('.Selectedsizecontent').append('<div class="szeChrtMblCommon"><div class="mblLeftHead">'+window['tableArr_'+getId][0][i]+'</div><div class="mblRightHead">'+v+'</div></div>');
      })
    }else
    {
      $('.Selectedsizecontent').hide();
    }
  }
}



/* Modal Size chart functionality */

//out of stock in cart page functionality

/* popup QR for */

$(document).ready(function(){
  $(".socials ul li").on("click",function(e){
    e.preventDefault();
    if($(this).find('img').attr('alt') =="Weibo")
    {
      e.preventDefault();
    }
    else if($(this).find('img').attr('alt') =="Weixin"){
      e.preventDefault();
    }
    else{
      var href = $(this).find('a').attr('href');
      window.open(href);
    }


  });

  $( ".socials ul li" ).each(function() {

    if($(this).find('img').attr('alt') =="Weibo")
    {
      $(this).find('img').click(function(){

        $('.weibo_qr').show();
        $('.weibo_qr').css({ 'visibility': 'visible'})

        $(".wrapper__overlay").css({'opacity':'0.5', 'visibility': 'visible'})

      });
    }

    if($(this).find('img').attr('alt') =="Weixin")
    {
      $(this).find('img').click(function(){

        $('.wechat_qr').show();
        $('.wechat_qr').css({ 'visibility': 'visible'})
        $(".wrapper__overlay").css({'opacity':'0.5', 'visibility': 'visible'})
      });
    }    
  });



  $('.wrapper__overlay').click(function(){

    //        $(".wrapper__overlay").css({'opacity':'0.5', 'visibility': 'hidden'})
    $('.weibo_qr').css({ 'visibility': 'hidden'})
    $('.wechat_qr').css({ 'visibility': 'hidden'})
  });
  $( ".socials ul li:eq(4)" ).click(function(e) {
    e.preventDefault();
  });

  $( ".socials ul li:eq(5)" ).click(function(e) {
    e.preventDefault();
  });
  $( ".socials ul li:eq(-2)" ).click(function(e) {
    e.preventDefault();
  });
  $( ".socials ul li:eq(-1)" ).click(function(e) {
    e.preventDefault();
  });


});


/*** product page image zoom ***/
$(document).ready(function(){
  setTimeout(function(){
    jQuery(document).ready(function(){
      jQuery('.product-gallery-slider .slider-for').each(function() { // the containers for all your galleries
        jQuery(this).magnificPopup({
          delegate: '.slider-gallery-image a', // the selector for gallery item
          type: 'image',
          gallery: {
            enabled:true
          },
          image: {
            verticalFit: true
          }
        });
      });
    });
  }, 1000);
});





/*** home page slider mobile View click start***/
homepagemobile();
$(window).resize(function() {
  homepagemobile();
});
function homepagemobile(){
  var mobile = getMobileOperatingSystem();
  if(mobile!="unknown"){
    if(mobile == "iOS" ||  mobile == "Android" || mobile == "Windows Phone" ){
      $('.intro__image').click(function(){
        var hr = $(this).attr("data-href");
        window.location.href= hr;
      });
    }
  }
}
/*** home page slider mobile View click end***/

/*** Lookbook mobile menu click start ***/
$(document).on("click",".lookbook_link", function(){
  var width = $(window).width();
  if(width>=320 && width<767){
    var mhf = $(this).attr("href");
    window.location.href=mhf;
    return false;
  }  
});
/*** Lookbook mobile menu click end ***/

/*** call us footer link click code start ***/
$(document).on("click",".call_us", function(){
  var width = $(window).width();
  var link = $(this).attr("data-link");
  if(width>=320 && width<767){  
    $(this).attr("href",'tel:'+link);
  }else{
    $(this).attr("href","/pages/contact-us");
  }
});
/*** call us footer link click code end ***/


// Hide USP banner for Bahrain. (safe guard pattern)
$( document ).ready(function() {
  setTimeout(function(){
    if ($("#FreeShippingBanner").length && $("#FreeShippingBanner").text().length > 0) {
      $('#shopify-section-header-usp').hide();
    }
    if ($("#header-usp").length === 0) {
      var headerEl = document.getElementById("shopify-section-header");
      if (headerEl) headerEl.style.top = "0";
      document.querySelectorAll(".filter__sticky").forEach(function(el) {
        el.style.top = "85px";
      });
    }
  }, 1000);
});           

var linkURL = $('.js-popup').attr('href');

function popupContent() {
  if (!linkURL || !$('.popup-faq .popup__inner').length) return;
  $.ajax({
    url: linkURL,
    type: 'GET'
  }).done(function(data) {
    var inner = $(data).find('.page-content').html();
    if (inner) $('.popup-faq .popup__inner').html(inner);
  });
}

if ($('.js-popup').length) popupContent();

$(document).on('click', '.js-popup', function(event) {
  event.preventDefault();

  $('.popup-faq').toggleClass('open')
});

// Cart Validate
$(document).ready(function() {
  var $cartAgree = $('.cart_agree');

  if ($cartAgree.length) {
    $('.cart-tooltip form, .form--cart').on('submit', function(event) {
      var $this = $(this);
      var $agree = $this.find('.cart_agree input');
      var $cartAgreeError = $this.find('.cart_agree-error');

      if (!$agree.is(":checked")) {        
        event.preventDefault();

        $cartAgreeError.show()
      }
    })
  }
})

// Css change on language select
$(document).ready(function() {
  const checkLanguage = (lang) => {
    if (lang === 'العربية‏' || lang === 'فارسی' || lang === 'עברית' || lang === 'كوردی') {
      $('.socials ul li:first').addClass('mr-left-30');
      $('.social-icons li:first').addClass('mr-left-30');
      $('.subscribe .subscribe__checkbox label').addClass('before-mr-left-5');
      $('.footer__nav a span').addClass('mr-left-5');
      $('.product-single .submit_btn').addClass('mr-right-15');
      $('.accordion-product .accordion__head a>i').addClass('left-0');
      $('.lookbook .lookbook__products').addClass('pd-right-51');
      $('.service__content').addClass('pd-right-43');
      $('.service__image').addClass('right-0');
      $('.section-collection .section__body-head .hidden-xs').addClass('mr-left-22');
      $('.collection-filters .filter-group li a').addClass('pd-left-0');
      $('#jasmine-collections .tab__content').addClass('pd-right-80');
      $('.section-collection .section__body').addClass('pd-right-35');
      $('.bridal-title').addClass('pd-top-15');
      $('.header__container .weglot-container').addClass('mr-left');
      $('.nav').addClass('pd-left-11');
      $('body').addClass('rtl-section');
      $('input#add-to-bag-btn').removeClass('mr-right-15');
    } else {
      $('.socials ul li:first').removeClass('mr-left-30');
      $('.social-icons li:first').removeClass('mr-left-30');
      $('.subscribe .subscribe__checkbox label').removeClass('before-mr-left-5');
      $('.footer__nav a span').removeClass('mr-left-5');
      $('.product-single .submit_btn').removeClass('mr-right-15');
      $('.accordion-product .accordion__head a>i').removeClass('left-0');
      $('.lookbook .lookbook__products').removeClass('pd-right-51');
      $('.service__content').removeClass('pd-right-43');
      $('.service__image').removeClass('right-0');
      $('.section-collection .section__body-head .hidden-xs').removeClass('mr-left-22');
      $('.collection-filters .filter-group li a').removeClass('pd-left-0');
      $('#jasmine-collections .tab__content').removeClass('pd-right-80');
      $('.section-collection .section__body').removeClass('pd-right-35');
      $('.bridal-title').removeClass('pd-top-15');
      $('.header__container .weglot-container').removeClass('mr-left');
      $('.nav').removeClass('pd-left-11');
      $('body').removeClass('rtl-section');
    }

    if (lang === 'English') {
      $('#header-usp').removeClass('hidden');
      $('.klarna-faq').removeClass('hidden');
    } else {
      $('#header-usp').addClass('hidden');
      $('.klarna-faq').addClass('hidden');
    }


}

  // setTimeout(function() { 
  //   checkLanguage($('.wg-li a:first').html())                   
  // }, 250); 

  $('.weglot_switcher ul:first').click(function() {
    setTimeout(() => {
      checkLanguage($('.wg-li a:first').html());
    }, 200);
  });

  $('.weglot_switcher ul').click(function() {
    setTimeout(() => {
      checkLanguage($('.wg-li a:first').html());
    }, 200);
  });

  // use mutation observer to detect when the language of text changes (safe guard)
  var target = document.querySelector('.header__container-content');
  if (target) {
    var observer = new MutationObserver(function(mutations) {
      mutations.forEach(function() {
        checkLanguage($('.wg-li a:first').html());
      });
    });
    observer.observe(target, {
      subtree: true,
      attributes: true,
      childList: true,
      characterData: true
    });
  }



});



$(document).on('click', '.dropdownbox', function(){
  $(".menu").toggleClass("showMenu");
  $(".menu > li").click(function(){
    $(".dropdownbox > p").html($(this).find('.size_get').html());
    $(".menu").removeClass("showMenu");
  });
});




//toggle layout view on mobile

$(document).ready(function() {

  if ($('#single-product-layout').is(':checked') && $(window).width() <= 576 ) {
      $('.product-grid').removeClass('grid--2-col-tablet-down ');
      $('.product-grid').addClass('grid--1-col-tablet-down');
    } else {
      $('.product-grid').removeClass('grid--1-col-tablet-down');
      $('.product-grid').addClass('grid--2-col-tablet-down');
    }
})

$(document).on("click", ".toggle-layout input", function() {
  if ($('#single-product-layout').is(':checked') && $(window).width() <= 576 ) {
    $('.product-grid').removeClass('grid--2-col-tablet-down');
    $('.product-grid').addClass('.grid--1-col-tablet-down');

  } else {
    $('.product-grid').removeClass('grid--1-col-tablet-down');
    $('.product-grid').addClass('grid--2-col-tablet-down');
  }
})

function addToBagUpdate(selectedSizeAvailable) {

  // Select elements
  const wrapperSelect = document.querySelector('.wrapper-select input[type="hidden"]');
  const addToBagBtn = document.querySelector('#add-to-bag-btn');
  const sizeOptions = document.querySelectorAll('.wrapper-select .size-options li');
  const addToWishlistBtn = document.querySelector('.swym-wishlist-button-bar.swym-button-bar');
  const tryBeforeYouBuyBtn = document.querySelector('.product-single .try-before-you-buy');

  // Ensure required elements exist
  if (!wrapperSelect || !addToBagBtn) {
    console.warn('Required elements (wrapperSelect or addToBagBtn) are missing.');
    return;
  }

  // Ensure sizeOptions has more than one list item
  if (!sizeOptions || sizeOptions.length <= 1) {
    return;
  }

  // Function to update the Add to Bag button state
  const updateAddToBagButton = (selectedSizeAvailable) => {
    const selectedValue = wrapperSelect.value.trim();

    if (selectedSizeAvailable == false) {
      return
    }
    if (selectedValue === '') {
      addToBagBtn.setAttribute('disabled', 'disabled');
      addToBagBtn.innerText = 'PLEASE SELECT SIZE';
      addToBagBtn.value = 'PLEASE SELECT SIZE';
      if (tryBeforeYouBuyBtn) tryBeforeYouBuyBtn.setAttribute('disabled', 'disabled');
      if (addToWishlistBtn) {
        addToWishlistBtn.style.opacity = '0.5';
        addToWishlistBtn.style.pointerEvents = 'none';
        addToWishlistBtn.style.userSelect = 'none';
        addToWishlistBtn.style.cursor = 'not-allowed';
      }
    } else {
      addToBagBtn.removeAttribute('disabled');
      addToBagBtn.innerText = 'ADD TO BAG';
      addToBagBtn.value = 'ADD TO BAG';
      addToBagBtn.classList.remove('notify');

      if (tryBeforeYouBuyBtn) tryBeforeYouBuyBtn.removeAttribute('disabled');
      if (addToWishlistBtn) {
        addToWishlistBtn.style.opacity = '1';
        addToWishlistBtn.style.pointerEvents = 'auto';
        addToWishlistBtn.style.userSelect = 'auto';
        addToWishlistBtn.style.cursor = 'pointer';
      }
    }
  };

  // Initial check on page load
  updateAddToBagButton(selectedSizeAvailable);

  // Listen for changes to the hidden input
  wrapperSelect.addEventListener('change', updateAddToBagButton);
}

// When the dropdown box is clicked
$('.selected-size').on('click', function  (event) {
  $('.size-options').toggleClass('active');
  $('.wrapper-select').toggleClass('active');
  let selectedSizeAvailable = true
  if (event.target.classList.contains('oos')) {
    selectedSizeAvailable = false;
  }
  addToBagUpdate(selectedSizeAvailable)
});

$('.size-options li').on('click', function  (event) {
  if($('.wrapper-select')){
    $('.selected-size span').remove();
    let selectedSizeAvailable = true
    if (event.target.classList.contains('oos')) {
      selectedSizeAvailable = false;
    }
    addToBagUpdate(selectedSizeAvailable)
  }
});

// When the dropdown box is keypressed with enter key
$('.selected-size').on('keypress', function  (event) {
  if (event.which == 13) {
    $('.size-options').toggleClass('active');
    $('.wrapper-select').toggleClass('active');
    let selectedSizeAvailable = true
    if (event.target.classList.contains('oos')) {
      selectedSizeAvailable = false;
    }
    addToBagUpdate(selectedSizeAvailable)
  }
});

$('.size-options li').on('keypress', function  (event) {
  if (event.which == 13) {
    if($('.wrapper-select')){
      $('.selected-size span').remove();
      let selectedSizeAvailable = true
      if (event.target.classList.contains('oos')) {
        selectedSizeAvailable = false;
      }
      addToBagUpdate(selectedSizeAvailable)
    }
  }
});


if($('.length-tab').length < 1 ) {
  $('.product-single__variants .length').css('display', 'none');
}


//Hide scrolling when size modal shows
$('.link-size-guide').on('click', function (event) {
	$('body').addClass('no-scroll');
});

$('.Modal__Close').on('click', function (event){
	$('body').removeClass('no-scroll');
});

// CUSTOMER REGISTER FORM
// When the day dropdown box is clicked
$('.dob-day-wrapper .custom-dropdown-selected').on('click', function  (event) {
  $('.dob-day-wrapper .custom-dropdown').toggleClass('active');
});

$('.dob-day-wrapper .custom-dropdown li').on('click', function  (event) {
	var value = event.currentTarget.value.toString().padStart(2, '0');
  	var display = event.currentTarget.innerHTML;
  	$('.dob-day-wrapper #field-dob-day').val(value);
  	$('.dob-day-wrapper .custom-dropdown-selected').html(display);
  	$('.dob-day-wrapper .custom-dropdown').removeClass('active');
});

// When the month dropdown box is clicked
$('.dob-month-wrapper .custom-dropdown-selected').on('click', function  (event) {
  $('.dob-month-wrapper .custom-dropdown').toggleClass('active');
});

$('.dob-month-wrapper .custom-dropdown li').on('click', function  (event) {
	var value = event.currentTarget.value.toString().padStart(2, '0');
  	var display = event.currentTarget.innerHTML;
  	$('.dob-month-wrapper #field-dob-month').val(value);
  	$('.dob-month-wrapper .custom-dropdown-selected').html(display);
  	$('.dob-month-wrapper .custom-dropdown').removeClass('active');
});

// When the year dropdown box is clicked
$('.dob-year-wrapper .custom-dropdown-selected').on('click', function  (event) {
  $('.dob-year-wrapper .custom-dropdown').toggleClass('active');
});

$('.dob-year-wrapper .custom-dropdown li').on('click', function  (event) {
	var value = event.currentTarget.value;
  	var display = event.currentTarget.innerHTML;
  	$('.dob-year-wrapper #field-dob-year').val(value);
  	$('.dob-year-wrapper .custom-dropdown-selected').html(display);
  	$('.dob-year-wrapper .custom-dropdown').removeClass('active');
});

//making the default layout double/grid view on load
$(window).on('load', function(){
  if(document.querySelector('label.double')){
  document.querySelector('label.double').click();
  }
})


function handleLanguageClick(event) {
  setTimeout(function() {
      let linkBackElements = document.querySelectorAll('.link-back');
      linkBackElements.forEach(function(element) {
          let existingEvents = element.onclick;
          if (!existingEvents) {
              element.addEventListener('click', function(event) {
                  event.preventDefault();
                  let findClassNames = element.className;
                  if (findClassNames.indexOf('firstAnchorClass') === -1) {
                      let closestNavDropdown = element.closest('.nav__dropdown');
                      closestNavDropdown.classList.remove('is-active', 'get1');
                  } else {
                      let navDropdowns = document.querySelectorAll('.nav__dropdown');
                      navDropdowns.forEach(function(navDropdown) {
                          navDropdown.classList.remove('is-active', 'get1');
                      });
                  }
              });
          }
      });
      let aElements = document.querySelectorAll('.weglot-mobile-container .weglot_switcher li a');
      aElements.forEach(function(element) {
          // Check if the element already has a click event listener
          let existingEvents = element.onclick;
          if (!existingEvents) {
              element.addEventListener('click', handleLanguageClick);
              element.parentNode.addEventListener('click', handleLanguageClick);
          }
      });
  }, 2000);
}

window.addEventListener('load', function(){
  setTimeout(function(){
      let liElements = document.querySelectorAll('.weglot-mobile-container .weglot_switcher li');
      liElements.forEach(function(element) {
          element.addEventListener('click', handleLanguageClick);
      });
      let aElements = document.querySelectorAll('.weglot-mobile-container .weglot_switcher li a');
      aElements.forEach(function(element) {
          element.addEventListener('click', handleLanguageClick);
      });
  }, 2000)
});

// Sub-collection titles button style slider arrows: START (safe guard pattern)
document.addEventListener("DOMContentLoaded", function() {
  const scrollContainer = document.querySelector(".subcategory-buttons--inner");
  const prevButton = document.querySelector(".buttons__prev");
  const nextButton = document.querySelector(".buttons__next");

  if (!scrollContainer || !prevButton || !nextButton) return;

  function updateArrowVisibility() {
    const maxScrollLeft = scrollContainer.scrollWidth - scrollContainer.clientWidth;
    prevButton.classList.toggle("hide", scrollContainer.scrollLeft <= 0);
    nextButton.classList.toggle("hide", scrollContainer.scrollLeft >= maxScrollLeft);
  }

  updateArrowVisibility();
  scrollContainer.addEventListener("scroll", updateArrowVisibility);
  window.addEventListener("resize", updateArrowVisibility);

  prevButton.addEventListener("click", () => {
    scrollContainer.scrollBy({ left: -200, behavior: "smooth" });
  });
  nextButton.addEventListener("click", () => {
    scrollContainer.scrollBy({ left: 200, behavior: "smooth" });
  });
});
// Sub-collection titles button style slider arrows: END

function initCarousels() {
  // Guard: wait until both jQuery and Slick are available
  if (typeof jQuery == 'undefined') {
    console.warn('Waiting for jQuery/Slick to load...');
    setTimeout(initCarousels, 50);
    return;
  }

  var $ = jQuery;

  if (typeof $.fn.slick === 'undefined') {
    console.warn('Waiting for Slick to load...');
    setTimeout(initCarousels, 50);
    return;
  }

  // =====================
  // Review Carousel
  // =====================
  var $reviewCarousel = $('.js-review-carousel');

  if ($reviewCarousel.length) {
    var slidesToShow = parseInt($reviewCarousel.data('slides-to-show')) || 3;
    var enableDots = $reviewCarousel.data('enable-dots') == true || $reviewCarousel.data('enable-dots') == 'true';
    var enableArrows = $reviewCarousel.data('enable-arrows') == true || $reviewCarousel.data('enable-arrows') == 'true';

    $reviewCarousel.slick({
      infinite: true,
      slidesToShow: slidesToShow,
      slidesToScroll: 1,
      dots: enableDots,
      arrows: enableArrows,
      responsive: [
        {
          breakpoint: 768,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
          }
        }
      ]
    });
  }

  // =====================
  // Shop The Style Carousel
  // =====================
  var $shopStyleCarousel = $('.js-shop-the-style-carousel');
  console.log('shopStyleCarousel', $shopStyleCarousel); // ← Fixed: was missing `$`

  if ($shopStyleCarousel.length) {
    var styleSlidesToShow = parseInt($shopStyleCarousel.data('slides-to-show')) || 4;

    $shopStyleCarousel.slick({
      slidesToShow: styleSlidesToShow,
      slidesToScroll: 1,
      responsive: [
        {
          breakpoint: 1024,
          settings: {
            slidesToShow: 1,
          }
        }
      ]
    });
  }
}

// =====================
// Tabs Logic
// =====================
document.addEventListener("DOMContentLoaded", function () {
  const tabNavItems = document.querySelectorAll('.tab-nav-item');
  const tabBodyItems = document.querySelectorAll('.tab-body-item');
  const tabItems = document.querySelectorAll('.tab-items');

  tabNavItems.forEach(element => {
    element.addEventListener('click', (e) => {
      let dataTabItem = e.target.getAttribute('data-tab-item-display');

      tabNavItems.forEach(item => {
        item.classList.remove('current');
      });

      e.target.classList.add('current');

      tabBodyItems.forEach(item => {
        if (dataTabItem === item.getAttribute('data-tab-body-display')) {
          item.classList.remove('js-tab-body-item-hide');
        } else {
          item.classList.add('js-tab-body-item-hide');
        }
      });

      tabItems.forEach((tabItem) => {
        if (tabItem.classList.contains(`${dataTabItem}-item`)) {
          tabItem.classList.add('js-tab-nav-item-filter');
          tabItem.classList.add('.js-tab-nav-item-show'); // kept EXACTLY same as original
        } else {
          tabItem.classList.remove('js-tab-nav-item-filter');
          tabItem.classList.remove('.js-tab-nav-item-show'); // kept EXACTLY same
        }
      });
    });
  });

  // First trigger
  if (tabNavItems.length > 0) {
    tabNavItems[0].click();
  }

  // Slick filtering
  tabNavItems.forEach((tabItem) => {
    tabItem.addEventListener('click', () => {
      setTimeout(() => {
        if (window.jQuery && jQuery('.js-shop-the-style-carousel').length) {
          jQuery('.js-shop-the-style-carousel').slick('slickUnfilter');
          jQuery('.js-shop-the-style-carousel').slick('slickFilter', '.js-tab-nav-item-filter');
        }
      }, 100);
    });
  });

  // Second trigger
  if (tabNavItems.length > 0) {
    tabNavItems[0].click();
  }
});

// =====================
// Initialize carousels
// =====================
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initCarousels);
} else {
  initCarousels();
}